import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "NoResultsWrapper" }
const _hoisted_2 = { class: "NoResultsText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _cache[1] || (_cache[1] = _createTextVNode(" There was an error loading the page. Please click here to ", -1 /* CACHED */)),
      _createElementVNode("button", {
        class: "ResetFilters",
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToRoot()))
      }, "make a fresh start.")
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("img", {
      src: "//monet-prtl-co.imgix.net/Shared/SearchPage/no_results.svg",
      class: "NoResultsImage",
      alt: "no results found"
    }, null, -1 /* CACHED */))
  ]))
}